import React from 'react';
import { styled } from '@material-ui/core/styles';
import { Typography, IconButton, Box } from '@material-ui/core';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import DeleteIcon from '@material-ui/icons/Delete';
import { useMinimizedDrawers } from './context/MinimizedDrawersContext';

const Wrapper = styled(Box)({
  position: 'fixed',
  bottom: 16,
  right: 16,
  zIndex: 200,
  display: 'flex',
  flexDirection: 'column-reverse',
  alignItems: 'flex-end',
  '&:hover': {
    gap: 16,
  },
  '&:hover .minimized-tab': {
    position: 'static',
  },
});

const MinimizedTab = styled(Box)({
  padding: '16px 24px',
  width: 279,
  justifyContent: 'space-between',
  display: 'flex',
  flexDirection: 'row',
  borderRadius: 8,
  backgroundColor: '#fff',
  cursor: 'pointer',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
});

const TabTitle = styled(Typography)({
  fontWeight: 700,
});

export const DiamMinimizedDisplayArea: React.FC = () => {
  const { minimizedDrawers, restoreDrawer, clearMinimizedDrawer } =
    useMinimizedDrawers();

  if (!minimizedDrawers || minimizedDrawers.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      {minimizedDrawers.map((drawer, index) => (
        <MinimizedTab
          key={drawer.id}
          className="minimized-tab"
          onClick={() => restoreDrawer(drawer.id)}
          sx={{ position: 'absolute', bottom: index * 30 }}
        >
          <Box display="flex" gridColumnGap={8} flexDirection="column">
            <Typography variant="caption">Draft</Typography>
            <TabTitle variant="subtitle2">{drawer.title}</TabTitle>
            {drawer.data?.name && (
              <Typography variant="subtitle2">{drawer.data.name}</Typography>
            )}
          </Box>
          <Box sx={{ margin: 'auto 0', flexShrink: 0 }}>
            <IconButton
              onClick={e => {
                e.stopPropagation();
                clearMinimizedDrawer(drawer.id);
              }}
            >
              <DeleteIcon color="error" />
            </IconButton>
            <IconButton
              style={{ background: '#1456E0', color: '#fff' }}
              onClick={e => {
                e.stopPropagation();
                restoreDrawer(drawer.id);
              }}
            >
              <FullscreenIcon color="inherit" />
            </IconButton>
          </Box>
        </MinimizedTab>
      ))}
    </Wrapper>
  );
};
